export { default as Double } from './double';
export { default as Triple } from './triple';
export { default as Text } from './text';
export { default as Image } from './image';
export { default as Carousel } from './carousel';




// WEBPACK FOOTER //
// ./src/components/blocks/block-types.js